import React from 'react';
import PropTypes from 'prop-types';
import PostActions from 'components/FeedList/Post/PostActions';
import { userShape, wallPostShape } from 'utils/shapes';
import { isSubdomain } from 'utils/web';
import './IFramePost.css';

function IFramePost({
  post,
  user,
  toggleComments,
  onUnpinWallPost,
  onPinWallPost,
  onLikePost,
  onUnlikePost,
  onDeletePost,
  onLockWallPost,
  onUnlockWallPost
}) {
  const json = JSON.parse(post.message);
  const {
    src,
    width = '29rem',
    height = '16.3125rem',
    title = 'External Content',
    showActions = true
  } = json;

  // Only allow URLs on our domain
  const valid = isSubdomain(src);

  return (
    <div className="feed-iframe-post">
      {!!valid && (
        <iframe
          title={title}
          src={src}
          style={{ width, height }}
          referrerPolicy="origin"
          //sandbox="allow-scripts"
        />
      )}
      {!!showActions && (
        <PostActions
          post={post}
          user={user}
          toggleComments={toggleComments}
          onUnpinWallPost={onUnpinWallPost}
          onPinWallPost={onPinWallPost}
          onLikePost={onLikePost}
          onUnlikePost={onUnlikePost}
          onDeletePost={onDeletePost}
          onLockWallPost={onLockWallPost}
          onUnlockWallPost={onUnlockWallPost}
        />
      )}
    </div>
  );
}

IFramePost.propTypes = {
  user: userShape,
  post: wallPostShape,
  onDeletePost: PropTypes.func,
  toggleComments: PropTypes.func,
  onLikePost: PropTypes.func,
  onUnlikePost: PropTypes.func,
  onPinWallPost: PropTypes.func,
  onUnpinWallPost: PropTypes.func
};

export default IFramePost;
